import { Stack, SxProps, Typography, useTheme } from "@mui/material";
import React from "react";

interface TitleWrapperProps {
  children: React.ReactNode;
  title?: string;
  headerContent?: React.ReactNode;
  sx?: SxProps;
  actions?: React.ReactNode;
}

const TitleWrapper = ({ children, title, headerContent, sx, actions }: TitleWrapperProps) => {
  const theme = useTheme();

  return (
    <Stack sx={{ width: "100%", ...sx }}>
      {title && (
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%", paddingBottom: theme.spacing(5) }}>
          <Typography variant="text4xl700" color="dsBase.v200">
            {title}
          </Typography>
          {actions || headerContent}
        </Stack>
      )}
      {children}
    </Stack>
  );
};

export default TitleWrapper;
